import { Form, Skeleton } from 'antd';
import React from 'react';
import styles from './SkeletonRow.module.scss';

const SkeletonRowImpl = (): JSX.Element => {
    return (
        <Form.Item hasFeedback={true}>
            <div className={styles['skeleton-row']}>
                <Skeleton paragraph={false} title={{ width: '100%' }} avatar={{ size: 'small', shape: 'circle' }} />
            </div>
        </Form.Item>
    );
};

export const SkeletonRow = React.memo(SkeletonRowImpl);
